import { debounce } from '@mui/material';
import { RiCloseLine, RiSearchLine } from '@remixicon/react';
import { useMemo } from 'react';
import { AgButton, AgInput } from 'src/components/ui';
import { useRefine } from 'src/providers/RefineProvider';
import { usePersistentSearch } from 'src/providers/SearchBoxProvider';

export type SearchBoxProps = { size?: 'sm' | 'md' | 'lg'; label?: string };

export default function SearchBox({ size = 'sm' }: SearchBoxProps) {
  const { query, handleOnChange } = usePersistentSearch();
  const { refine } = useRefine();

  const debounceSearch = useMemo(() => {
    return debounce((value: string) => {
      refine(value);
    }, 100);
  }, [refine]);

  return (
    <AgInput
      aria-label="Search"
      placeholder="Search"
      size={size}
      value={query}
      onChange={(value) => handleOnChange(value)}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          debounceSearch((e.target as HTMLInputElement).value);
          e.preventDefault();
        }
      }}
      wrapperClassName="flex-grow max-w-[400px]"
      startContent={<RiSearchLine className="h-4 w-4" />}
      endContent={
        query ? (
          <AgButton variant="ghost" size="icon-xs" shape="circle" onPress={() => handleOnChange('')}>
            <RiCloseLine className="h-4 w-4" />
          </AgButton>
        ) : null
      }
    />
  );
}
